import api from './api';

const getAll = (pagination, filter, language, sortColumn) => api.get('/mini-guide', {
    pageNum: pagination.currentPage - 1,
    pageLength: pagination.itemsPerPage,
    active: filter.active,
    search: filter.search,
    language: language,
    sortBy: sortColumn.sortByColumn,
    orderBy: sortColumn.orderBy
}).then(response => {
    return response.data;
});

const getById = (id) => api.get(`/mini-guide/${id}`).then(response => {
    return response.data
});

const create = (data) => api.post('/mini-guide', data).then(response => {
    return response.data
});

const update = (id, data) => api.put(`/mini-guide/${id}`, data).then(response => {
    return response.data
});

const remove = (id) => api.delete(`/mini-guide/${id}`).then(response => {
    return response.data
});

const MiniGuideService = {
    getAll,
    getById,
    create,
    update,
    remove
};

export default MiniGuideService;